import { configureCognito, isConfigured } from '@/auth/cognito.service';
import { configureAxiosBaseUrl, ProxyAxios } from '@/lib/request';
import '@assets/styles.less';
import '@components/i18n/i18n';
import Page from '@components/Page';
import AppProvider from '@components/shared/layout/AppProvider';
import { QupitalFooter } from '@components/shared/layout/QupitalFooter';
import { GlobalStyles } from '@components/styles/GlobalStyles';
import { init as SentryInit } from '@sentry/node'; //controlled by webpack node or browser
import { configStore } from '@services/store';
import axios from 'axios';
import withReduxSaga from 'next-redux-saga';
import withRedux from 'next-redux-wrapper';
import App from 'next/app';
import Head from 'next/head';
import Router from 'next/router';
import NProgress from 'nprogress';
import React from 'react';
import { Provider } from 'react-redux';
import { isUndefined } from 'util';

Router.events.on('routeChangeStart', () => NProgress.start());
Router.events.on('routeChangeComplete', () => NProgress.done());
Router.events.on('routeChangeError', () => NProgress.done());

SentryInit({
  enabled: !!process.env.SENTRY_DSN,
  dsn: process.env.SENTRY_DSN,
  release: process.env.RELEASE_NAME,
  logLevel: 1
});


const HtmlHeadConfig = () => (
  <Head>
    <meta
      name="viewport"
      content="user-scalable=no,initial-scale=1,maximum-scale=1,minimum-scale=1,width=device-width,height=device-height"
    />
    <meta charSet="utf-8" />
    <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
     <meta name="viewport" content="width=1280, initial-scale=1.0"></meta>
    <title>Qupital Funder Platform</title>
    <link rel="shortcut icon" href={require("@/static/favicon.ico")} />
    <script async src="https://cdnjs.cloudflare.com/ajax/libs/babel-polyfill/7.2.5/polyfill.min.js" />
  </Head>
);

let cognitoConfig;

class FunderApp extends App {

  static async getInitialProps(context) {
    const { ctx: { req }, ctx } = context;

    let protocol = 'https:';

    let host = req ? req.headers.host : `${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`;

    if (host.indexOf('localhost') > -1 || host.indexOf('127.0.0.1') > -1) {
      protocol = 'http:';
    }
    let baseUrl = `${protocol}//${host}`;

    configureAxiosBaseUrl(baseUrl);

    if (isUndefined(cognitoConfig))
      cognitoConfig = await axios.get(`${baseUrl}/api/client-config/auth`).then(resp => resp.data || resp);

    if (!isConfigured())
      configureCognito(cognitoConfig, ctx);

    const appProps = await App.getInitialProps(context);
    return { ...appProps, baseUrl, cognitoConfig }
  }

  render() {
    const { Component, pageProps, store, baseUrl, cognitoConfig } = this.props;
    // expose store when run in Cypress
    if (typeof window !== 'undefined' && window.Cypress)
      window.store = store;

    if (!ProxyAxios.defaults.baseURL)
      configureAxiosBaseUrl(baseUrl);

    if (!isConfigured())
      configureCognito(cognitoConfig);

    return (
      <>
        <GlobalStyles />
        <HtmlHeadConfig />

        <Provider store={store}>
          <AppProvider>
            <Page>
              <Component {...pageProps} />
            </Page>
            {typeof document !== 'undefined' && Router.pathname !== '/user/login' ? <QupitalFooter /> : null}

          </AppProvider>
        </Provider>
      </>
    );
  }
}

export default withRedux(configStore)(withReduxSaga(FunderApp))
